<div class="w-full bg-white border-box radius-10" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="length-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Informations sur l'élection</p>
            <p class="no-margin dark-gray text-sm">Durée des mandats des élus CSE et nombre de collèges</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>

  <div *ngIf="isExpanded" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="length-grid"
    class="p-20">
    <div style="grid-column: 1 / -1;">
      <p class="dark-gray no-margin mb-5">Tour concerné <span class="red">*</span></p>
      <div class="flex gap-10">
        <p class="dark-blue bold">{{round.firstRound ? 'Premier tour' : 'Second tour'}}</p>
        <!-- <label class="flex align-items-center gap-5 pointer dark-blue">
          <input type="radio" name="firstRound" [value]="true" [(ngModel)]="round.firstRound"> Premier tour
        </label>
        <label class="flex align-items-center gap-5 pointer dark-blue">
          <input type="radio" name="firstRound" [value]="false" [(ngModel)]="round.firstRound"> Second tour
        </label> -->
      </div>
    </div>
    <div style="grid-column: 1 / -1;" *ngIf="!round.firstRound">
      <p class="dark-blue bold">{{round.shortage ? 'Carence premier tour' : 'Suite au résultats du premier tour'}}</p>
      <!-- <div class="flex">
        <div style="width: 5px; align-self: stretch;" class="bg-pastel-blue">
        </div>
        <div class="p-20">
          <p class="dark-blue no-margin mb-5">Contexte du second tour <span class="red">*</span></p>
          <div class="flex flex-column gap-10">
            <label class="flex align-items-center gap-5 pointer dark-blue">
              <input type="radio" name="shortage" [value]="true" [(ngModel)]="round.shortage"> Carence premier tour
            </label>
            <label class="flex align-items-center gap-5 pointer dark-blue">
              <input type="radio" name="shortage" [value]="false" [(ngModel)]="round.shortage"> Suite au résultats du
              premier tour
            </label>
          </div>
        </div>
      </div> -->

    </div>
    <!-- <p class="dark-gray no-margin">Années</p> -->
    <p class="dark-gray no-margin" style="grid-column: 1 / -1;">Durée des mandats et nombre de collèges</p>
    <div>
      <p class="dark-gray no-margin">Années</p>
      <p class="dark-blue bold">{{termLength.duration[0]}} an(s)</p>
      <!-- <input [(ngModel)]="termLength.duration[0]" (ngModelChange)="validateYears()" (wheel)="$event.preventDefault()"
        type="number" min="0" max="4" name="years" id="years" class="w-full text-md dark-blue pap-input"
        value="{{termLength.duration[0]}}"> -->
    </div>
    <!-- <p class="dark-blue bold">{{termLength.duration[0]}} an(s)</p> -->

    <!-- <p class="dark-gray no-margin">Mois</p> -->
    <div>
      <p class="dark-gray no-margin">Mois</p>
      <p class="dark-blue bold">{{termLength.duration[1]}} mois</p>
      <!-- <input [(ngModel)]="termLength.duration[1]" (ngModelChange)="validateMonths()" (wheel)="$event.preventDefault()"
        type="number" min="0" max="11" name="months" id="months" class="w-full text-md dark-blue pap-input"
        value="{{termLength.duration[1]}}"> -->
    </div>
    <!-- <p class="dark-blue bold">{{termLength.duration[1]}} mois</p> -->

    <div>
      <p class="dark-gray no-margin">Nombre de collèges</p>
      <p class="dark-blue bold">{{headcount.numberOfColleges}}</p>
      <!-- <input [(ngModel)]="headcount.numberOfColleges" (wheel)="$event.preventDefault()"
        (ngModelChange)="onNumberOfCollegesChange()" type="number" name="numberOfColleges" id="numberOfColleges"
        class="w-full text-md dark-blue pap-input" value="{{headcount.numberOfColleges}}" min="1" max="4"> -->
    </div>
  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">
      Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>
  </div>
</div>